var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import * as A from "fp-ts/Array";
import { pipe } from "fp-ts/function";
import { fromPredicate } from "fp-ts/Option";
import * as T from "fp-ts/Tree";
import { fromTraversable, Lens, Prism } from "monocle-ts";
const getExtractor = (nodesAccessor) => (root) => {
  class TraversalExtractor {
    constructor(traversal, tree2) {
      __publicField(this, "traversal");
      __publicField(this, "tree");
      this.traversal = traversal;
      this.tree = tree2;
    }
    filter(predicate) {
      return new TraversalExtractor(
        this.traversal.composePrism(Prism.fromPredicate(predicate)),
        this.tree
      );
    }
    map(mapper) {
      return new TraversalExtractor(
        this.traversal.composeLens(new Lens(mapper, () => (dt) => dt)),
        this.tree
      );
    }
    chain(mapper) {
      return pipe(this.get(), A.map(mapper));
    }
    get() {
      return pipe(
        this.traversal.asFold().getAll(this.tree),
        A.map(fromPredicate(Boolean)),
        A.compact
      );
    }
  }
  const tree = T.unfoldTree(root, (node) => [node, nodesAccessor(node)]);
  return new TraversalExtractor(fromTraversable(T.tree)(), tree);
};
export {
  getExtractor
};
//# sourceMappingURL=extractor-infra.js.map
